import { Box, Flex } from '@chakra-ui/react';

import { accent, font, fontSize, neutral, text } from 'styles/revampTokens';

export type ExportPanelTab = 'download' | 'distribution';

interface ExportPanelTabBarProperties {
  activeTab: ExportPanelTab;
  onChange: (tab: ExportPanelTab) => void;
}

const TABS: { id: ExportPanelTab; label: string }[] = [
  { id: 'download', label: 'Download now' },
  { id: 'distribution', label: 'Automatic distribution' },
];

/**
 * Underline tabs for the export modal — navigation, not primary actions.
 */
const ExportPanelTabBar = ({ activeTab, onChange }: ExportPanelTabBarProperties) => {
  return (
    <Flex
      role='tablist'
      aria-label='Export options'
      gap={6}
      borderBottom={`1px solid ${neutral.border}`}
    >
      {TABS.map(({ id, label }) => {
        const selected = activeTab === id;
        return (
          <Box
            key={id}
            as='button'
            type='button'
            role='tab'
            aria-selected={selected}
            onClick={() => onChange(id)}
            pb={3}
            mb='-1px'
            px={0}
            fontFamily={font.body}
            fontSize={fontSize.body}
            fontWeight={selected ? 600 : 500}
            lineHeight='1.25'
            color={selected ? text.primary : text.secondary}
            bg='transparent'
            border='none'
            borderBottom='2px solid'
            borderBottomColor={selected ? accent.solid : 'transparent'}
            borderRadius={0}
            cursor='pointer'
            whiteSpace='nowrap'
            transition='color 0.15s ease, border-color 0.15s ease'
            _hover={{ color: text.primary }}
          >
            {label}
          </Box>
        );
      })}
    </Flex>
  );
};

export default ExportPanelTabBar;
